export default {
  ApplicationInfo: 'Information',
  Game: 'Spiel',
  Account: 'Konto',
  Server: 'Server',
  CharacterName: 'Charaktername',
  PlatformOrderNumber: 'Plattform-Bestellnummer',
  Amount: 'Betrag',
  InvoiceMethod: 'Rechnungsdetails',
  InvoiceByTotalOrderAmount:
    'Rechnung gemäß der Gesamtsumme mehrerer Bestellungen ausstellen.',
  InvoiceByOrderAmountSeparately:
    'Separate Rechnungen für mehrere Bestellungen basierend auf dem Betrag jeder einzelnen Bestellung ausstellen.',
  PhoneNumber: 'Kontaktnummer',
  Name: 'Name',
  Address: 'Adresse',
  InvoiceTitle: 'Rechnung an',
  PersonalTitleOnlyNoCompany:
    'Bitte gib deinen Namen ein. Trage nicht den Namen einer Firma oder Organisation ein.',
  ReceivingEmail: 'E-Mail',
  Remarks: 'Hinweis',
  InputContent: 'Hier eingeben',
  ApplicationSubmittedSuccessfully: 'Anforderung eingereicht',
  InvoiceApplicationSubmittedSuccessfully:
    'Deine Rechnungsanforderung wurde eingereicht.\r\nUnser Team wird sie innerhalb von 7 Werktagen bearbeiten. Bitte überprüfe deine E-Mail.',
  Confirm: 'Bestätigen',
  Submit: 'Einreichen',
  ApplicationSubmissionFailed: 'Anforderung konnte nicht eingereicht werden.',
  InvoiceApplicationFailed:
    'Deine Rechnungsanforderung wurde nicht eingereicht. Bitte aktualisiere die Seite und versuche es erneut oder kontaktiere den Kundendienst.',
  InvoiceApplicationSubmitted:
    'Deine Anforderung wurde eingereicht. Bitte reiche sie nicht erneut ein.',
  PleaseEnterName: 'Bitte Namen eingeben',
  PleaseEnterAddress: 'Bitte Adresse eingeben',
  PleaseEnterInvoiceTitle: 'Bitte Namen des Empfängers eingeben',
  PleaseEnterEmail: 'Bitte E-Mail-Adresse eingeben',
  PleaseEnterRemarks: 'Bei Bedarf einen Hinweis eingeben',
  NumberParsingError: 'Ungültige Nummer',
  PleaseEnterValidEmailFormat: 'Bitte gib eine gültige E-Mail-Adresse ein.',
  IncompleteInformation: 'Unvollständige Informationen, bitte überprüfen.',
  ExpandAll: 'Alle zeigen'
};
